<div class="broker-dialog">

  <!-- Header -->
  <div class="broker-header">
    <h2 class="broker-title">
      <mat-icon>account_balance</mat-icon>
      Login Broker
    </h2>
    <button mat-icon-button (click)="dialogRef.close()" class="close-button" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="broker-content">

    <!-- ── Login tabs (only when not yet connected) ── -->
    <div *ngIf="!authenticated && !connected">

      <mat-tab-group #tabgroup [selectedIndex]="selectedTabIndex"
          mat-stretch-tabs="false" mat-align-tabs="start"
          animationDuration="0ms"
          (selectedTabChange)="onTab2Change(tabgroup, $event)"
          class="broker-tab-group">

        <!-- Gateway tab -->
        <mat-tab [disabled]="metaApi && suscribirseForm">
          <ng-template mat-tab-label>
            <img src="assets/logos/interactive-brokers-stacked.svg" class="tab-logo" alt="">
            <img src="assets/logos/interactive-brokers-stacked-inverse.svg" class="tab-logo tab-logo-dark" alt="">
            <span>Gateway</span>
          </ng-template>
          <div class="tab-body">
            <ng-container *ngIf="ibkrPermitido; else ibkrBloqueado">

              <!-- Sesión de MetaTrader 5 abierta: solo se opera con un bróker a la vez -->
              <div *ngIf="sesionMetaApiActiva && !authenticated" class="info-block">
                <mat-icon class="info-icon warn">swap_horiz</mat-icon>
                <p>Tienes abierta una sesión de <b>MetaTrader 5</b><ng-container *ngIf="cuentaMetaApiActiva"> ({{ cuentaMetaApiActiva }})</ng-container>.</p>
                <p>Solo se puede operar con un bróker a la vez. Ciérrala para iniciar sesión en Interactive Brokers.</p>
                <button mat-flat-button class="ccorbit broker-btn" (click)="cerrarSesionMetaApiParaIbkr()">
                  Cerrar sesión MetaTrader 5 y continuar
                </button>
              </div>

              <ng-container *ngIf="!sesionMetaApiActiva || authenticated">

              <!-- Permiso "Acceso a la red local" bloqueado en el navegador -->
              <div *ngIf="lnaEstado === 'denied'" class="info-block">
                <mat-icon class="info-icon warn">block</mat-icon>
                <p>Tu navegador bloqueó el acceso al Gateway local.</p>
                <ol class="lna-steps">
                  <li>Haz clic en el icono a la izquierda de la dirección web.</li>
                  <li>Activa <b>"Otras aplicaciones y servicios de este dispositivo"</b> (Acceso a la red local).</li>
                  <li>La conexión se reanudará automáticamente.</li>
                </ol>
                <button mat-flat-button class="ccorbit broker-btn" (click)="reintentarPermisoGateway()">
                  Ya lo habilité, reintentar
                </button>
              </div>

              <!-- Aviso del navegador ignorado o cerrado (o Gateway sin ejecutar) -->
              <div *ngIf="lnaPendiente && lnaEstado !== 'denied'" class="info-block">
                <mat-icon class="info-icon warn">warning_amber</mat-icon>
                <p>No se pudo conectar con el Gateway local.</p>
                <p>Si el navegador te preguntó por <b>"Acceder a otras aplicaciones y servicios de este dispositivo"</b>, pulsa <b>Permitir</b>.
                  Si no apareció ningún aviso, verifica que el Gateway esté instalado y en ejecución.</p>
                <button mat-flat-button class="ccorbit broker-btn" (click)="reintentarPermisoGateway()">
                  Reintentar conexión
                </button>
                <button mat-button (click)="instalarGateway()">
                  Instalar Gateway
                </button>
              </div>

              <ng-container *ngIf="!lnaBloqueaGateway">
                <div *ngIf="!gwnoinstalado">
                  <button mat-flat-button class="ccorbit broker-btn" (click)="loginGateway()" [disabled]="iniciando">
                    Iniciar Sesión Gateway
                  </button>
                </div>
                <!-- Permiso aún sin decidir: anticipar el aviso del navegador -->
                <div *ngIf="gwnoinstalado && lnaEstado === 'prompt'" class="info-block">
                  <mat-icon class="info-icon">lan</mat-icon>
                  <p>Tu navegador te pedirá permiso para <b>"Acceder a otras aplicaciones y servicios de este dispositivo"</b>.
                    Pulsa <b>Permitir</b> para conectar con el Gateway.</p>
                </div>
                <div *ngIf="gwnoinstalado && lnaEstado !== 'prompt'" class="info-block">
                  <mat-icon class="info-icon warn">warning_amber</mat-icon>
                  <p>Gateway no instalado. Por favor instálalo para poder iniciar sesión.</p>
                  <button mat-flat-button class="ccorbit broker-btn" (click)="instalarGateway()" [disabled]="iniciando">
                    Instalar Gateway
                  </button>
                </div>
              </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </mat-tab>

        <!-- OAuth tab -->
        <mat-tab [disabled]="(metaApi && suscribirseForm) || !ibkrPermitido">
          <ng-template mat-tab-label>
            <img src="assets/logos/interactive-brokers-stacked.svg" class="tab-logo" alt="">
            <img src="assets/logos/interactive-brokers-stacked-inverse.svg" class="tab-logo tab-logo-dark" alt="">
            <span>OAuth</span>
          </ng-template>
          <div class="tab-body">
            <ng-container *ngIf="ibkrPermitido; else ibkrBloqueado">

              <!-- Sesión de MetaTrader 5 abierta: solo se opera con un bróker a la vez -->
              <div *ngIf="sesionMetaApiActiva && !authenticated" class="info-block">
                <mat-icon class="info-icon warn">swap_horiz</mat-icon>
                <p>Tienes abierta una sesión de <b>MetaTrader 5</b><ng-container *ngIf="cuentaMetaApiActiva"> ({{ cuentaMetaApiActiva }})</ng-container>.</p>
                <p>Solo se puede operar con un bróker a la vez. Ciérrala para iniciar sesión en Interactive Brokers.</p>
                <button mat-flat-button class="ccorbit broker-btn" (click)="cerrarSesionMetaApiParaIbkr()">
                  Cerrar sesión MetaTrader 5 y continuar
                </button>
              </div>

              <div *ngIf="(!sesionMetaApiActiva || authenticated) && tipooauth==1 && _cookieService.get('liveSessionToken') =='' ">
                <p class="tab-hint">Copia los Token de acceso y Secreto de token de acceso generados en la página de autoservicio.</p>

                <div *ngIf="oauthVerifier == ''">
                  <label class="field-label">Selecciona una llave</label>
                  <select [(ngModel)]="cuentaSeleccionada"
                      (change)="onCuentaSeleccionada(cuentaSeleccionada)"
                      class="broker-select">
                    <option *ngFor="let cuenta of cuentasBroker" [value]="cuenta">{{ cuenta }}</option>
                  </select>
                </div>

                <div *ngIf="oauthVerifier == ''" class="fields-stack">
                  <div>
                    <label class="field-label">Token de acceso</label>
                    <input type="text" class="broker-input" placeholder="Token de acceso"
                           [formControl]="myControl" [(ngModel)]="accessToken" />
                  </div>
                  <div>
                    <label class="field-label">Secreto de token</label>
                    <input type="text" class="broker-input" placeholder="Secreto de token de acceso"
                           [formControl]="myControl" [(ngModel)]="tokenSecret" />
                  </div>
                  <button mat-flat-button class="ccorbit broker-btn" (click)="getlivesesssiontoken();"
                          [disabled]="tokenSecret==''">
                    Generar Live Session
                  </button>
                </div>
              </div>

              <div *ngIf="!sesionMetaApiActiva && !connected && !authenticated && _cookieService.check('liveSessionToken')">
                <button mat-flat-button class="ccorbit broker-btn" (click)="compete()" [disabled]="iniciando">
                  Iniciar Sesión
                </button>
              </div>

            </ng-container>
          </div>
        </mat-tab>

        <!-- MetaAPI tab -->
        <mat-tab [disabled]="!metaApi && suscribirseForm">
          <ng-template mat-tab-label>
            <img src="assets/logos/metatrader5.svg" class="tab-logo" alt="">
            <img src="assets/logos/metatrader5-inverse.svg" class="tab-logo tab-logo-dark" alt="">
            <span>MetaTrader 5</span>
          </ng-template>
          <div class="tab-body">
            <ng-container *ngIf="metapiPermitido; else metapiBloqueado">

            <!-- Sesión de IBKR abierta: solo se opera con un bróker a la vez -->
            <div *ngIf="connected && authenticated" class="info-block">
              <mat-icon class="info-icon warn">swap_horiz</mat-icon>
              <p>Tienes abierta una sesión de <b>Interactive Brokers</b>.</p>
              <p>Solo se puede operar con un bróker a la vez. Ciérrala para conectar una cuenta de MetaTrader 5.</p>
              <button mat-flat-button class="ccorbit broker-btn" (click)="cerrarSesion()">
                Cerrar sesión Interactive Brokers
              </button>
            </div>

            <ng-container *ngIf="!(connected && authenticated)">

            <!-- Already connected + from suscripciones -->
            <ng-container *ngIf="metaApi && suscribirseForm && isMetaApiConnected; else metaApiForm">
              <p class="tab-hint text-center">Cuenta MetaAPI activa</p>
              <div class="metaapi-account-card">
                <mat-icon class="metaapi-icon">cloud_done</mat-icon>
                <div class="metaapi-account-info">
                  <span class="metaapi-account-id">{{ metaApiAccountId }}</span>
                  <span class="metaapi-account-label">Account ID (MT4/MT5)</span>
                </div>
              </div>
              <div class="vincular-row">
                <p class="tab-hint">Se vinculará esta cuenta al modelo seleccionado.</p>
                <ng-container *ngTemplateOutlet="syncOptimaCheck"></ng-container>
              </div>
              <p class="error-msg" *ngIf="metaApiError">{{ metaApiError }}</p>
              <button mat-flat-button class="ccorbit broker-btn" (click)="conectarMetaApi()" [disabled]="metaApiConectando">
                {{ metaApiConectando ? 'Vinculando...' : 'Vincular cuenta' }}
              </button>
            </ng-container>

            <!-- Default form -->
            <ng-template #metaApiForm>

              <!-- Fuente: MetaAPI en la nube o Nectum MT5 Gateway en este equipo -->
              <div class="metaapi-mode-toggle" *ngIf="cloudHabilitado">
                <button [class.active]="metaApiFuente === 'CLOUD'" (click)="setMetaApiFuente('CLOUD')"
                    [disabled]="metaApiConectando || desplegando || creandoCuenta || mt5GwConectando">
                  MetaAPI (nube)
                </button>
                <button [class.active]="metaApiFuente === 'GATEWAY'" (click)="setMetaApiFuente('GATEWAY')"
                    [disabled]="metaApiConectando || desplegando || creandoCuenta || mt5GwConectando">
                  Gateway local
                </button>
              </div>

              <!-- ── Gateway local ── -->
              <ng-container *ngIf="metaApiFuente === 'GATEWAY'">

                <!-- Permiso "Acceso a la red local" bloqueado en el navegador -->
                <div *ngIf="lnaEstado === 'denied'" class="info-block">
                  <mat-icon class="info-icon warn">block</mat-icon>
                  <p>Tu navegador bloqueó el acceso al Gateway MT5 local.</p>
                  <ol class="lna-steps">
                    <li>Haz clic en el icono a la izquierda de la dirección web.</li>
                    <li>Activa <b>"Otras aplicaciones y servicios de este dispositivo"</b> (Acceso a la red local).</li>
                    <li>La conexión se reanudará automáticamente.</li>
                  </ol>
                  <button mat-flat-button class="ccorbit broker-btn" (click)="reintentarMt5Gateway()">
                    Ya lo habilité, reintentar
                  </button>
                </div>

                <div *ngIf="lnaPendiente && lnaEstado !== 'denied'" class="info-block">
                  <mat-icon class="info-icon warn">warning_amber</mat-icon>
                  <p>No se pudo conectar con el Gateway MT5 local.</p>
                  <p>Si el navegador te preguntó por <b>"Acceder a otras aplicaciones y servicios de este dispositivo"</b>, pulsa <b>Permitir</b>.</p>
                  <button mat-flat-button class="ccorbit broker-btn" (click)="reintentarMt5Gateway()">
                    Reintentar conexión
                  </button>
                </div>

                <ng-container *ngIf="!lnaBloqueaGateway">

                  <div *ngIf="mt5GwNoInstalado && lnaEstado === 'prompt'" class="info-block">
                    <mat-icon class="info-icon">lan</mat-icon>
                    <p>Tu navegador te pedirá permiso para <b>"Acceder a otras aplicaciones y servicios de este dispositivo"</b>.
                      Pulsa <b>Permitir</b> para conectar con el Gateway MT5.</p>
                  </div>

                  <div *ngIf="mt5GwNoInstalado && lnaEstado !== 'prompt'" class="info-block">
                    <mat-icon class="info-icon warn">warning_amber</mat-icon>
                    <p>No se detecta el <b>Nectum MT5 Gateway</b> en este equipo.</p>
                    <p>Instálalo (requiere MetaTrader 5 de tu bróker). Si ya lo instalaste, ábrelo desde el menú Inicio.</p>
                    <button mat-flat-button class="ccorbit broker-btn" (click)="instalarMt5Gateway()">
                      Descargar Gateway MT5
                    </button>
                  </div>

                  <div *ngIf="!mt5GwEstado && !mt5GwNoInstalado" class="metaapi-deploy-banner">
                    <mat-spinner diameter="16" class="metaapi-spinner"></mat-spinner>
                    <span>Buscando el Gateway MT5 local...</span>
                  </div>

                  <ng-container *ngIf="mt5GwEstado as gw">

                    <!-- Varios MetaTrader 5 instalados: elegir con cuál trabaja el gateway -->
                    <div *ngIf="mt5GwTerminales.length > 1" class="metaapi-region-row">
                      <label class="field-label" for="mt5gw-terminal">Terminal</label>
                      <select id="mt5gw-terminal" class="broker-input metaapi-region-select"
                          [ngModel]="mt5GwTerminalActivo" (ngModelChange)="onTerminalMt5GwChange($event)"
                          [disabled]="mt5GwCambiandoTerminal || mt5GwConectando || mt5GwIniciandoSesion">
                        <option value="" disabled *ngIf="!mt5GwTerminalActivo">Selecciona un terminal</option>
                        <option *ngFor="let t of mt5GwTerminales" [value]="t.path">
                          {{ t.name }}<ng-container *ngIf="t.lastLogin"> · {{ t.lastLogin }} ({{ t.lastServer }})</ng-container><ng-container *ngIf="!t.running"> · cerrado</ng-container>
                        </option>
                      </select>
                    </div>
                    <div *ngIf="mt5GwCambiandoTerminal" class="metaapi-deploy-banner">
                      <mat-spinner diameter="16" class="metaapi-spinner"></mat-spinner>
                      <span>Conectando con el terminal...</span>
                    </div>

                    <div *ngIf="!gw.initialized" class="info-block">
                      <mat-icon class="info-icon warn">desktop_access_disabled</mat-icon>
                      <p>El gateway está en marcha pero no encuentra el terminal <b>MetaTrader 5</b>.</p>
                      <p>Abre MetaTrader 5 de tu bróker; la conexión se reanudará sola.</p>
                    </div>

                    <!-- Cuenta abierta en el terminal -->
                    <ng-container *ngIf="gw.terminalConnected && gw.accountId">
                      <div class="metaapi-account-card">
                        <mat-icon class="metaapi-icon">computer</mat-icon>
                        <div class="metaapi-account-info">
                          <span class="metaapi-account-id">{{ gw.login }}<ng-container *ngIf="gw.name"> · {{ gw.name }}</ng-container></span>
                          <span class="metaapi-account-label">{{ gw.server }}<ng-container *ngIf="gw.company"> · {{ gw.company }}</ng-container></span>
                        </div>
                      </div>
                      <p class="tab-hint" *ngIf="!gw.algoTradingEnabled">
                        <mat-icon class="small-icon">warning_amber</mat-icon>
                        Activa <b>Algo Trading</b> en MetaTrader 5 para poder enviar órdenes.
                      </p>
                      <p class="tab-hint" *ngIf="gw.sessionsSource === 'inferred' && gw.sessionsServiceInstalled">
                        Para usar el horario de sesiones exacto, inicia el servicio <b>NectumGatewaySessions</b>
                        en MetaTrader 5 (Navegador → Servicios).
                      </p>
                      <p class="error-msg" *ngIf="mt5GwError">{{ mt5GwError }}</p>
                      <ng-container *ngTemplateOutlet="syncOptimaCheck"></ng-container>
                      <button mat-flat-button class="ccorbit broker-btn" (click)="conectarMt5Gateway()"
                          [disabled]="mt5GwConectando || metaApiConectando || mt5GwCambiandoTerminal">
                        {{ mt5GwConectando || metaApiConectando ? 'Conectando...' : (suscribirseForm ? 'Vincular esta cuenta' : 'Conectar esta cuenta') }}
                      </button>
                      <button mat-button *ngIf="!mt5GwMostrarLogin" (click)="mt5GwMostrarLogin = true"
                          [disabled]="mt5GwConectando">
                        Usar otra cuenta
                      </button>
                    </ng-container>

                    <!-- Login MT5 desde la web (las credenciales solo van al gateway local) -->
                    <div *ngIf="gw.initialized && (mt5GwMostrarLogin || !gw.terminalConnected)" class="fields-stack">
                      <p class="tab-hint" *ngIf="!gw.terminalConnected">
                        MetaTrader 5 está abierto pero sin una cuenta conectada. Inicia sesión en el terminal o aquí:
                      </p>
                      <div>
                        <label class="field-label">Login MT5</label>
                        <input type="number" class="broker-input" placeholder="Número de cuenta MT5" [(ngModel)]="mt5GwLogin" />
                      </div>
                      <div>
                        <label class="field-label">Contraseña MT5</label>
                        <input type="password" class="broker-input" placeholder="Contraseña de la cuenta" [(ngModel)]="mt5GwPassword" autocomplete="off" />
                      </div>
                      <div>
                        <label class="field-label">Servidor MT5</label>
                        <input type="text" class="broker-input" placeholder="Ej: ICMarketsSC-Demo" [(ngModel)]="mt5GwServer" />
                      </div>
                      <p class="tab-hint">Las credenciales se envían solo al gateway de este equipo; Nectum no las guarda.</p>
                      <p class="error-msg" *ngIf="mt5GwError && !gw.terminalConnected">{{ mt5GwError }}</p>
                      <button mat-flat-button class="ccorbit broker-btn" (click)="iniciarSesionMt5Gateway()"
                          [disabled]="mt5GwIniciandoSesion || !mt5GwLogin || !mt5GwPassword || !mt5GwServer">
                        {{ mt5GwIniciandoSesion ? 'Iniciando sesión...' : 'Iniciar sesión en MetaTrader 5' }}
                      </button>
                    </div>

                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- ── MetaAPI en la nube ── -->
              <ng-container *ngIf="metaApiFuente === 'CLOUD'">

              <div class="metaapi-deploy-banner" *ngIf="desplegando">
                <mat-spinner diameter="16" class="metaapi-spinner"></mat-spinner>
                <span>{{ deployMessage }}</span>
              </div>
              <div class="metaapi-deploy-banner metaapi-deploy-error" *ngIf="deployError && !desplegando">
                <mat-icon style="font-size:16px;width:16px;height:16px;">error_outline</mat-icon>
                <span>{{ deployError }}</span>
                <button mat-button class="metaapi-retry-btn" (click)="deployYConectar(metaApiAccountInput, '')">
                  Reintentar
                </button>
              </div>

              <div class="metaapi-mode-toggle">
                <button [class.active]="metaApiMode === 'login'" (click)="setMetaApiMode('login')"
                    [disabled]="cuentasCloudMetaApi.length === 0">
                  Cuentas guardadas
                </button>
                <button [class.active]="metaApiMode === 'crear'" (click)="setMetaApiMode('crear')">
                  Nueva cuenta
                </button>
                <!--button [class.active]="metaApiMode === 'manual'" (click)="setMetaApiMode('manual')">
                  Mi token
                </button-->
              </div>

              <div class="metaapi-region-row">
                <label class="field-label" for="metaapi-region-login">Región</label>
                <select id="metaapi-region-login" class="broker-input metaapi-region-select"
                    [ngModel]="regionLogin" (ngModelChange)="onRegionLoginChange($event)"
                    [disabled]="metaApiConectando || desplegando || creandoCuenta">
                  <option *ngFor="let r of metaApiRegiones" [value]="r">{{ r }}</option>
                </select>
              </div>

              <!-- Saved accounts -->
              <div *ngIf="metaApiMode === 'login' && cuentasCloudMetaApi.length > 0" class="fields-stack">
                <label class="field-label">Selecciona una cuenta</label>
                <div class="metaapi-saved-account-item"
                    *ngFor="let cuenta of cuentasCloudMetaApi"
                    [class.selected]="metaApiSelectedCuenta?.metaApiAccountId === cuenta.metaApiAccountId"
                    (click)="elegirCuentaGuardada(cuenta)">
                  <div class="metaapi-saved-account-main">
                    <span class="metaapi-saved-login">{{ cuenta.nombre || cuenta.mtLogin }}</span>
                    <span class="metaapi-saved-server">{{ cuenta.mtServer }}</span>
                  </div>
                  <div class="metaapi-saved-estado" [class.deployed]="cuenta.estado === 'DEPLOYED'">
                    <mat-icon>{{ cuenta.estado === 'DEPLOYED' ? 'cloud_done' : 'cloud_off' }}</mat-icon>
                  </div>
                </div>
                <p class="error-msg" *ngIf="metaApiError">{{ metaApiError }}</p>
                <button mat-flat-button class="ccorbit broker-btn"
                    (click)="seleccionarCuentaGuardada()"
                    [disabled]="metaApiConectando || desplegando || creandoCuenta || !metaApiSelectedCuenta">
                  {{ (metaApiConectando || desplegando) ? 'Conectando...' : 'Conectar' }}
                </button>
              </div>

              <!-- New account -->
              <div *ngIf="metaApiMode === 'crear'" class="fields-stack">
                <div>
                  <label class="field-label">Login MT5</label>
                  <input type="number" class="broker-input" placeholder="Número de cuenta MT5" [(ngModel)]="mtLogin" />
                </div>
                <div>
                  <label class="field-label">Contraseña MT5</label>
                  <input type="password" class="broker-input" placeholder="Contraseña de la cuenta" [(ngModel)]="mtPassword" />
                </div>
                <div>
                  <label class="field-label">Servidor MT5</label>
                  <input type="text" class="broker-input" placeholder="Ej: ICMarkets-Live" [(ngModel)]="mtServer" />
                </div>
                <p class="error-msg" *ngIf="metaApiError">{{ metaApiError }}</p>
                <button mat-flat-button class="ccorbit broker-btn"
                    (click)="crearCuentaMetaApi()"
                    [disabled]="creandoCuenta || desplegando || !mtLogin || !mtPassword || !mtServer || metapiLimiteAlcanzado">
                  {{ creandoCuenta ? 'Creando cuenta...' : (desplegando ? 'Iniciando servidor...' : 'Crear y Conectar') }}
                </button>
                <p class="tab-hint text-center" *ngIf="metapiLimiteAlcanzado">
                  Ha alcanzado el límite de servidores MetaAPI habilitados por su plan actual ({{ cuentasCloudMetaApi.length }}/{{ metapiLimite }}).
                  Para agregar un nuevo servidor, amplíe su licencia contactando a soporte.
                </p>
              </div>

              <!-- Manual token -->
              <div *ngIf="metaApiMode === 'manual'" class="fields-stack">
                <div>
                  <label class="field-label">Auth Token MetaAPI</label>
                  <input type="password" class="broker-input" placeholder="MetaAPI auth-token" [(ngModel)]="metaApiToken" />
                </div>
                <div>
                  <label class="field-label">Account ID</label>
                  <input type="text" class="broker-input" placeholder="MT4/MT5 Account ID" [(ngModel)]="metaApiAccountInput" />
                </div>
                <p class="error-msg" *ngIf="metaApiError">{{ metaApiError }}</p>
                <button mat-flat-button class="ccorbit broker-btn"
                    (click)="conectarMetaApi()"
                    [disabled]="metaApiConectando || !metaApiToken || !metaApiAccountInput">
                  {{ metaApiConectando ? 'Conectando...' : 'Conectar MetaAPI' }}
                </button>
              </div>

              </ng-container>

            </ng-template>

            </ng-container>

            </ng-container>
          </div>
        </mat-tab>

      </mat-tab-group>

      <ng-template #ibkrBloqueado>
        <div class="info-block">
          <mat-icon class="info-icon warn">block</mat-icon>
          <p>No cuentas con la licencia para operar con IBKR. <a href="https://nectum-investment.com/" target="_blank" rel="noopener">Adquiere tu licencia aquí</a>.</p>
          <p>Si crees que esto es un error, consulta a soporte.</p>
        </div>
      </ng-template>

      <ng-template #metapiBloqueado>
        <div class="info-block">
          <mat-icon class="info-icon warn">block</mat-icon>
          <p>No cuentas con la licencia para operar con MetaAPI. <a href="https://nectum-investment.com/" target="_blank" rel="noopener">Adquiere tu licencia aquí</a>.</p>
          <p>Si crees que esto es un error, consulta a soporte.</p>
        </div>
      </ng-template>
    </div>

    <!-- ── Account selection (after login) ── -->
    <div *ngIf="!loading && !notificacion" class="account-section">

      <div class="section-header">
        <mat-icon class="small-icon">manage_accounts</mat-icon>
        Seleccionar cuenta
      </div>

      <select class="broker-select" [(ngModel)]="carteraSeleccionada">
        <option [ngValue]="cartera" *ngFor="let cartera of carterasBroker">{{ cartera }}</option>
      </select>

      <button mat-flat-button class="ccorbit broker-btn" (click)="abrirCartera()"
          *ngIf="connected && authenticated && !suscribirseForm">
        Abrir cuenta
      </button>
      <ng-container *ngIf="connected && authenticated">
        <ng-container *ngTemplateOutlet="syncOptimaCheck"></ng-container>
      </ng-container>
      <button mat-flat-button class="ccorbit broker-btn" (click)="suscribirse()"
          *ngIf="connected && authenticated && suscribirseForm">
        Vincular cuenta Broker / Cartera suscrita
      </button>
      <button class="btn-logout" (click)="cerrarSesion()" *ngIf="connected && authenticated">
        <mat-icon>logout</mat-icon>
        Cerrar sesión Broker
      </button>

    </div>

  </div>
</div>

<!-- Solo al vincular desde Suscripciones: la cartera del broker toma los parámetros de su cartera óptima -->
<ng-template #syncOptimaCheck>
  <div class="sync-optima-check" *ngIf="suscribirseForm && data?.opcionesVinculo">
    <mat-checkbox [(ngModel)]="data.opcionesVinculo.sincronizarOptima" color="primary">
      Sincronizar cartera óptima
    </mat-checkbox>
  </div>
</ng-template>
